<header *ngIf="{ isSessionOpen: isSessionOpen$ | async } as data" class="header">

	<ng-template #menuUsuario>
		<menu-usuario (onOpenSugerencias)="onOpenSugerencias()"></menu-usuario>
	</ng-template>


	<!-- Small header container -->
	<div class="container header__container--sm">

		<!-- Mini menu + Intranet Logo -->
		<div class="intranet__container--sm">
			<div *ngIf="data.isSessionOpen" (click)="onSidebarSelected()" class="menu-icon menu-item" gtagEvent="ver-menú-lateral" gtagCategory="header">
				<div class="menu-icon__bar"></div>
				<div class="menu-icon__bar"></div>
				<div class="menu-icon__bar"></div>
			</div>
			<div class="intranet-logo intranet-logo-svg menu-item" routerLink="/principal/inicio" gtagEvent="ver-inicio"
				gtagCategory="header"></div>
		</div>

		<ng-container *ngIf="data.isSessionOpen">
			<!-- Search input -->
			<div class="search__container--sm" *ngIf="isCollapsedSearchVisible()">
				<!--
				<form action="#" class="search">
					<input type="text" class="search__input" placeholder="Buscar">
					<button class="search__button"></button>
				</form>
				-->
				<div (click)="onCollapsedSearchClose()" class="search__close--sm"></div>
			</div>

			<!-- User options -->
			<div class="user__container--sm" *ngIf="isUserContainerSmallVisible()">
				<!-- User options -->
				<div class="user__item--options" ngbDropdown (openChange)="onMenuUsuarioChange( $event )" placement="bottom-right">
					<div ngbDropdownToggle aria-labelledby="user__options" class="user__item--container-sm">
						<user-photo class="user__image" [photo]="sessionUserPhoto$ | async"></user-photo>
						<div class="user__down-arrow">
							<span></span>
							<span></span>
						</div>
					</div>
					<div ngbDropdownMenu aria-labelledby="user__options">
						<ng-container *ngTemplateOutlet="menuUsuario"></ng-container>
					</div>
				</div>

				<!-- Mesa de ayuda -->
				<div class="user__mesa-ayuda" routerLink="/principal/mesa-ayuda"
					routerLinkActive="user__mesa-ayuda--selected" gtagEvent="ver-mesa-ayuda" gtagCategory="header">
				</div>

				<!-- Restaurar versión anterior -->
				<div class="user__version-anterior" (click)="onRestaurarVersionAnterior()" gtagEvent="restaurar-versión-anterior" gtagCategory="header"></div>

				<!-- Search option -->
				<!--
				<div (click)="onCollapsedSearchOpen()" *ngIf="isCollapsedSearchIconVisible()" class="user__search--sm"></div>
				-->
			</div>
		</ng-container>

	</div>

	<!-- Normal header container -->
	<div class="container header__container">
		<div class="row header__box">

			<!-- Intranet Logo -->
			<div class="col-2 logo__container">
				<div class="intranet-logo" routerLink="/principal/inicio" gtagEvent="ver-inicio" gtagCategory="header">
				</div>
			</div>

			<ng-container *ngIf="isSessionOpen$ | async">
				<!-- Search input -->
				<div class="col search__container">
					<!--
					<form action="#" class="search">
						<input type="text" class="search__input" placeholder="Buscar personas, áreas jerárquicas y números de internos">
						<button class="search__button"></button>
					</form>
					-->
				</div>

				<div class="col-8 user__container">

					<!-- User options -->
					<div class="user__item--options" ngbDropdown placement="bottom-right">
						<div ngbDropdownToggle aria-labelledby="user__options" class="user__item--container">
							<div class="user__image" [ngStyle]="userPhoto$ | async"></div>
							<div class="user__item--text">{{userName$ | async}}</div>
							<div class="user__down-arrow">
								<span></span>
								<span></span>
							</div>
						</div>
						<div ngbDropdownMenu aria-labelledby="user__options">
							<ng-container *ngTemplateOutlet="menuUsuario"></ng-container>
						</div>
					</div>

					<!-- Mesa de ayuda -->
					<div class="user__item--container mesa-ayuda__container" routerLink="/principal/mesa-ayuda"
						routerLinkActive="user__item--container-active" gtagEvent="ver-mesa-ayuda"
						gtagCategory="header">
						<div class="user__mesa-ayuda"></div>
						<div class="user__item--text">Mesa de Ayuda</div>
					</div>

					<!-- Restaurar versión anterior -->
					<div class="user__item--container version-anterior__container" (click)="onRestaurarVersionAnterior()"
						gtagEvent="restaurar-versión-anterior" gtagCategory="header">
						<div class="user__version-anterior"></div>
						<div class="user__item--text">Restaurar versión anterior</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</header>

<encuesta-satisfaccion #encuesta></encuesta-satisfaccion>
